module.exports = __webpack_public_path__ + "static/media/fashion-brands.de7359e5.jpg";